import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { PkPdfData } from "../../types/CityObjectPdfData";
import { formatFinnishDate } from "../../utilities/PdfUtils";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 9, fontFamily: "Helvetica" },
  title: { fontSize: 14, fontWeight: "bold", marginBottom: 2 },
  subtitle: { fontSize: 11, fontWeight: "demibold", marginBottom: 2 },
  contractLine: { fontSize: 9, marginBottom: 4 },
  divider: { borderBottomWidth: 1, borderBottomColor: "#999", marginBottom: 10 },
  entryBox: { border: 1, borderColor: "#ddd", padding: 8, marginBottom: 8 },
  entryDate: { fontSize: 10, fontWeight: "bold", marginBottom: 4 },
  fieldRow: { flexDirection: "row", marginBottom: 2 },
  fieldLabel: { width: "25%", fontWeight: "bold" },
  fieldValue: { width: "75%" },
  emptyMsg: { fontStyle: "italic", color: "#666" },
  footer: { position: "absolute", bottom: 20, left: 30, right: 30, textAlign: "center", fontSize: 8, color: "#666" },
});

interface Props {
  data: PkPdfData;
}

const Field = ({ label, value }: { label: string; value: string | null | undefined }) => {
  if (!value) return null;
  return (
    <View style={styles.fieldRow}>
      <Text style={styles.fieldLabel}>{label}</Text>
      <Text style={styles.fieldValue}>{value}</Text>
    </View>
  );
};

const PkPDF = ({ data }: Props) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>Work Diary (PK) — #{data.perceptionId}</Text>
      <Text style={styles.subtitle}>{data.location}</Text>
      <Text style={styles.contractLine}>Contract: {data.contractName}</Text>
      <View style={styles.divider} />

      {data.diaryEntries.length === 0 ? (
        <Text style={styles.emptyMsg}>No diary entries recorded.</Text>
      ) : (
        data.diaryEntries.map((entry) => (
          <View key={entry.id} style={styles.entryBox}>
            <Text style={styles.entryDate}>{formatFinnishDate(entry.diaryDate)}</Text>
            <Field label="Weather" value={entry.weather} />
            {entry.temperature1 != null && (
              <Field
                label="Temperature"
                value={`${entry.temperature1}°C${entry.temperature2 != null ? ` / ${entry.temperature2}°C` : ""}`}
              />
            )}
            <Field label="Supervisor" value={entry.supervisor} />
            <Field label="Foreman" value={entry.foreman} />
            <Field label="Workers" value={entry.workers} />
            <Field label="Tasks" value={entry.tasks} />
            <Field label="Machines" value={entry.machines} />
            <Field label="Description" value={entry.description} />
            <Field label="Subscriber notices" value={entry.subscriberNotices} />
            <Field label="Notices to subscriber" value={entry.noticesToSubscriber} />
          </View>
        ))
      )}

      <Text style={styles.footer} render={({ pageNumber, totalPages }) => `Page ${pageNumber} / ${totalPages}`} fixed />
    </Page>
  </Document>
);

export default PkPDF;
